(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (root = document) => {
    root.querySelectorAll('[data-hero-slider]:not([data-ready])').forEach(slider => {
      slider.dataset.ready = 'true';
      const slides = [...slider.querySelectorAll('[data-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-hero-dot]')];
      const pause = slider.querySelector('[data-hero-pause]');
      const track = slider.querySelector('.hero-slides');
      let index = 0;
      let paused = false;
      let focused = false;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide,i) => {
          slide.hidden = false;
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden',String(i !== index));
        });
        track.style.transform = 'translateX(-'+index*100+'%)';
        dots.forEach((dot,i) => dot.setAttribute('aria-pressed',String(i === index)));
      };
      show(0);
      dots.forEach((dot,i) => dot.addEventListener('click',() => show(i)));
      slider.querySelector('[data-hero-prev]')?.addEventListener('click',() => show(index-1));
      slider.querySelector('[data-hero-next]')?.addEventListener('click',() => show(index+1));
      pause?.addEventListener('click',() => {
        paused = !paused;
        pause.setAttribute('aria-pressed',String(paused));
        pause.setAttribute('aria-label',paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        pause.textContent = paused ? '▶' : 'Ⅱ';
      });
      slider.addEventListener('focusin',() => focused = true);
      slider.addEventListener('focusout',event => focused = slider.contains(event.relatedTarget));
      if (slider.dataset.autoplay === 'true' && slides.length > 1) {
        const timer = setInterval(() => {
          if (!slider.isConnected) { clearInterval(timer); return; }
          if (!paused && !focused && !document.hidden && !reducedMotion.matches) show(index+1);
        },5000);
      }
      if (pause && reducedMotion.matches) {
        paused = true;
        pause.setAttribute('aria-pressed','true');
        pause.setAttribute('aria-label',pause.dataset.playLabel);
        pause.textContent = '▶';
      }
    });
    root.querySelectorAll('[data-product-carousel]:not([data-ready])').forEach(carousel => {
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-product-track]');
      const previous = carousel.querySelector('[data-product-prev]');
      const next = carousel.querySelector('[data-product-next]');
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth-2;
      };
      previous.addEventListener('click',() => track.scrollBy({left:-track.clientWidth*.85,behavior:reducedMotion.matches?'instant':'smooth'}));
      next.addEventListener('click',() => track.scrollBy({left:track.clientWidth*.85,behavior:reducedMotion.matches?'instant':'smooth'}));
      track.addEventListener('scroll',update,{passive:true});
      new ResizeObserver(update).observe(track);
      update();
    });
    root.querySelectorAll('[data-quick-card]:not([data-ready])').forEach(card => {
      card.dataset.ready = 'true';
      const dialog = card.querySelector('[data-quick-dialog]');
      const form = dialog.querySelector('form');
      const trigger = card.querySelector('[data-quick-open]');
      const submit = form.querySelector('[type="submit"]');
      const variant = form.querySelector('[data-quick-variant]');
      const status = form.querySelector('[data-quick-status]');
      const outerStatus = card.querySelector('[data-quick-card-status]');
      trigger.addEventListener('click',() => {
        if (trigger.hasAttribute('data-quick-direct')) form.requestSubmit();
        else { dialog.showModal(); variant?.focus(); }
      });
      card.querySelector('[data-quick-close]').addEventListener('click',() => dialog.close());
      dialog.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close',() => trigger.focus({preventScroll:true}));
      variant?.addEventListener('change',() => {
        const option = variant.selectedOptions[0];
        const money = card.querySelector('[data-quick-price] [data-money]');
        submit.disabled = !variant.value || option.disabled;
        form.querySelector('[name="quantity"]').value = option.dataset.minimum || '1';
        if (money && option.dataset.amount) {
          money.dataset.amount = option.dataset.amount;
          money.dataset.original = option.dataset.money;
          money.textContent = option.dataset.money;
          document.dispatchEvent(new CustomEvent('valessia:prices:update'));
        }
      });
      form.addEventListener('submit',async event => {
        event.preventDefault();
        if (form.dataset.busy === 'true' || !form.reportValidity()) return;
        form.dataset.busy = 'true';
        submit.disabled = true;
        trigger.disabled = true;
        status.textContent = '';
        outerStatus.textContent = '';
        const base = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(base+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal:AbortSignal.timeout(20000)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || status.dataset.error);
          status.textContent = status.dataset.success;
          outerStatus.textContent = status.dataset.success;
          try {
            const cartResponse = await fetch(base+'cart.js',{headers:{Accept:'application/json'},signal:AbortSignal.timeout(10000)});
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              if (Number.isInteger(cart.item_count)) document.querySelectorAll('.cart-count').forEach(el => el.textContent=cart.item_count);
            }
          } catch {}
        } catch (error) {
          const message = error.name === 'TimeoutError' ? status.dataset.error : error.message || status.dataset.error;
          status.textContent = message;
          outerStatus.textContent = message;
        } finally {
          form.dataset.busy = 'false';
          submit.disabled = !!variant && !variant.value;
          trigger.disabled = false;
        }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
